import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCall from "@/components/StickyMobileCall";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  const hideStickyOnAdmin = pathname.startsWith("/admin");

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {!hideStickyOnAdmin && <StickyMobileCall />}
      <div className="fg-mobile-cta-spacer" aria-hidden />
    </div>
  );
}
